<template>
  <v-container fluid>
    <h1 class="display-inline">Contacts List</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <v-row>
      <v-col cols="12">
        <ClientsContactList></ClientsContactList>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import ClientsContactList from "../components/clients/ClientsContactList"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";


export default {
  name: "ContactList",
  permissions: [...ClientsContactList.permissions],
  components: {
    ActiveApiCalls,
    ClientsContactList
  },
  methods: {},
  mounted() {
  },
  data() {
    return {}
  },
}

</script>

<style scoped>

</style>